import { graphql, Slice } from "gatsby";
import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/common/SEO";
import VideoSection from "../components/home/VideoSection";
import LatestArticles from "../components/stories/LatestArticles";
import ReviewCarousel from "../components/home/ReviewCarousel";

const CLUB_ACTIVE = process.env.GATSBY_CLUB_ACTIVE;

const Home = ({ data }) => {
  const contentfulData = data.ContentfulData;

  const hero = function () {
    if (CLUB_ACTIVE === "club_pt") {
      return (
        <Slice alias="home-hero" data={contentfulData.heroSectionPartners} />
      );
    } else {
      return <Slice alias="home-hero" data={contentfulData.heroSection} />;
    }
  };

  return (
    <Layout>
      <div className="w-full min-h-screen flex flex-col">
        {hero()}
        <Slice
          alias="home-categories"
          bushbuckContentful={contentfulData.bushbuckCategories}
        />
        <Slice alias="home-products" />
        <VideoSection data={contentfulData.videoSection} />
        <LatestArticles
          title={contentfulData.blogSectionTitle}
          description={
            contentfulData.blogSectionDescription.blogSectionDescription
          }
          articles={contentfulData.blogs}
        />
        {/* <Slice
          alias="home-campfire"
          title={contentfulData.blogSectionTitle}
          description={
            contentfulData.blogSectionDescription.blogSectionDescription
          }
          blogs={contentfulData.blogs}
        /> */}
        <Slice alias="home-shop" />
        <Slice alias="home-joinclub" />
        <ReviewCarousel />
      </div>
    </Layout>
  );
};

export const query = graphql`
  query LandingPageData {
    ContentfulData: contentfulLandingPage(
      contentful_id: { eq: "6U5WsczwymBgG6one5ad3L" }
    ) {
      seoComponent {
        title
        metaDescription {
          metaDescription
        }
        icon
        logo
      }
      heroSection {
        caption
        title
        description {
          description
        }
        buttonText
        buttonLink
        backgroundImage {
          mimeType
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 2000
          )
          title
          file {
            url
          }
        }
        backgroundImageMobile {
          mimeType
          title
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 760
          )
          file {
            url
          }
        }
      }
      heroSectionPartners {
        title
        description {
          description
        }
        buttonText
        buttonLink
        backgroundImage {
          mimeType
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 2000
          )
          title
          file {
            url
          }
        }
        backgroundImageMobile {
          mimeType
          title
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 760
          )
          file {
            url
          }
        }
      }
      bushbuckCategories {
        title
        shopifyId
        image {
          title
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 500
          )
        }
        buttonText
        buttonLink
      }
      videoSection {
        title
        description {
          description
        }
        buttonText
        buttonLink
        backgroundImage {
          mimeType
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 2000
          )
          title
          file {
            url
          }
        }
        backgroundImageMobile {
          mimeType
          title
          gatsbyImageData(
            formats: WEBP
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 760
          )
          file {
            url
          }
        }
      }
      blogSectionTitle
      blogSectionDescription {
        blogSectionDescription
      }
      blogs {
        title
        slug
        createdAt(formatString: "MMMM DD YYYY")
        contributor {
          title
        }
        thumbnailImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: DOMINANT_COLOR
            formats: WEBP
            breakpoints: 1200
          )
        }
        categories {
          title
          slug
        }
      }
    }
  }
`;

export function Head({ location, data }) {
  return <SEO location={location} data={data?.ContentfulData?.seoComponent} />;
}

export default Home;
